<template>
<Nav />
<Content>
  
  <h2 class="title">Account Settings</h2>
  
  <div class="box">
    
    <div v-if="claims.given_name && claims.given_name.length > 0" class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">Name</label></div>
      <div class="field-body">
        <div class="control is-expanded">
          <input class="input" type="text" :value="claims.given_name" readonly>
        </div>
      </div>
    </div>
    
    <div  v-if="claims.family_name && claims.family_name.length > 0" class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">Family Name</label></div>
      <div class="field-body">
        <div class="control is-expanded">
          <input class="input" type="text" :value="claims.family_name" readonly>
        </div>
      </div>
    </div>
    
    <div class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">Email</label></div>
      <div class="field-body">
        <div class="control is-expanded">
          <input class="input" type="text" :value="claims.email" readonly>
        </div>
      </div>
    </div>
    
    <div v-if="orgs && orgs.length > 0" class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">Orgs</label></div>
      <div class="field-body">
        <p class="tags are-medium is-expanded">
          <span v-for="org in orgs" class="tag">
            {{ org }}
          </span>
        </p>
      </div>
    </div>
    
    <br>
    
    <div class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">User ID</label></div>
      <div class="field-body">
        <p class="control is-expanded">
          <input class="input" type="text" :value="claims.sub" readonly>
        </p>
      </div>
    </div>
    
    <div class="field is-horizontal has-addons">
      <div class="field-label is-normal"><label class="label">Is Admin:</label></div>
      <div class="field-body">
        <p class="control is-expanded">
          <input class="input" type="text" :value="isAdmin" readonly>
        </p>
      </div>
    </div>

    <div class="field is-horizontal has-addons" v-if="isAdmin">
      <div class="field-label is-normal"><label class="label">Login Remaining (min)</label></div>
      <div class="field-body">
        <p class="control is-expanded">
          <input class="input" type="text" :value="Math.floor(remaining)" readonly>
        </p>
      </div>
    </div>
  </div>
  <br>

  <div class="box" v-if="isAdmin">
    <div class="button" @click="showConfig = !showConfig">Show Configuration</div>
    <span v-if="showConfig">
      <p></p>
      <p v-for="(value, key) in portalConfig">{{key}}: {{value}}</p>
    </span>
  </div>

  <div class="box" v-if="isAdmin">
    <div class="button" @click="showToken = !showToken">Show token</div>
    <span v-if="showToken" class="is-expanded">
      <p></p>
      <p v-for="(value, key) in claims">{{key}}: {{value}}</p>
      <textarea class="textarea" type="text" :value="tokens['id_token']" readonly></textarea>
    </span>
  </div>

  <div class="box" v-if="isAdmin">
    <div class="button" @click="mlButtonClicked">Show ML</div>
    <span v-if="showMl">
      <p></p>
      <p>Ml url: {{ mlUrl }}</p>
      <p>MlState: {{ mlState }}</p>
      <div class="buttons">
        <button class="button" @click="resetMlState">Refresh...</button>
        <button class="button" @click="mlStartClicked">Start...</button>
      </div>
    </span>
  </div>

</Content>
<Footer />
</template>


<script>
import { mapState, mapGetters, mapActions } from 'pinia'
import { useLogin, login_cognito, config } from '@/js/auth.js'
import { getMlState, startMl } from '@/js/apis.js'

import Nav from '@/components/Nav.vue'
import Content from '@/components/Content.vue'
import Footer from '@/components/Footer.vue'


export default {
    components: { Nav, Footer, Content },
    data() {
        return {
            id_token: "",
            remaining: -1,
            showConfig: false,
            showToken: false,
            showMl: false,
            mlState: "getting it...",
        }
    },
    created(){
        this.remaining = this.getRemaining() / 60
        console.log(process.env.VUE_APP_API_URL)
    },
    methods: {
        ...mapActions(useLogin, ["login"]),
        mlStartClicked(){
            if (this.isAdmin){
                startMl().then(() => {this.resetMlState()})
            }
        },
        mlButtonClicked(){
            this.showMl = !this.showMl
            if (this.showMl){
                this.resetMlState()
            }
        },
        resetMlState(){
            this.mlState = "getting instance state..."
            if (this.isAdmin){
                getMlState().then((resp) => {this.mlState = resp.state})
            }
        }
    },
    computed: {
        ...mapGetters(useLogin, ["claims", "getRemaining", "tokens", "isAdmin"]),
        orgs(){
            if ("custom:org" in this.claims) {
                return this.claims["custom:org"].split(",")
            } else {
                return
            }
        },
        portalConfig() {
            return {
                mlUrl: process.env.VUE_APP_ML_URL,
                apiUrl: process.env.VUE_APP_API_URL,
                bucketName: process.env.VUE_APP_BUCKET_SOUNDS,
                bucketRegion: process.env.VUE_APP_BUCKET_REGION,
                cognitoRegion: process.env.VUE_APP_COGNITO_REGION,
                cognitoIdentityPoolId: process.env.VUE_APP_IDENTITY_POOL,
                cognitoUserPoolName: process.env.VUE_APP_USERPOOL_NAME,
                cognitoUserPoolId: process.env.VUE_APP_USERPOOL_ID,
                cognitoUserPoolId: process.env.VUE_APP_USERPOOL_ID,
                cognitoAppClient: process.env.VUE_APP_USERPOOL_CLIENT,
                cognitoFlow: process.env.VUE_APP_USERPOOL_FLOW,
            }
        },
        mlUrl(){
            return process.env.VUE_APP_ML_URL
        },
        apiUrl(){
            return process.env.VUE_APP_API_URL
        },
    },
}
</script>
  
